module.exports = __webpack_public_path__ + "static/7-52433bbf5d9c22724a848c527ef1cfd7.jpg";